/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_Source_ErpInputs */

const vi_online_price_source_erp = /** @type {(inputs: Online_Price_Source_ErpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo giá ERP`)
};

/**

* @param {Online_Price_Source_ErpInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_source_erp = /** @type {((inputs?: Online_Price_Source_ErpInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Source_ErpInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_source_erp(inputs)
});